<template>
  <div class="archive">
    <span>
      <md-icon class="icon-action" tabindex="-1" v-popover:archive slot="reference">restore</md-icon>
      <md-tooltip md-delay="300">Show archived elements</md-tooltip>
    </span>
    <el-popover
        placement="bottom-start"
        title="Archived milestones"
        ref="archive"
        trigger="click"
        width="400"
        v-model="popoverVisible">
        <div class="archive-popover">
          <table class="archive-table">
              <tr>
                  <th style="min-width:120px;">Name</th>
                  <th colspan="2" style="min-width:50px;">Actions</th>
              </tr>
              <tr v-for="(milestone, i) in milestones" :key="i">
                  <td style="vertical-align:top" :title="milestone.name">
                    {{milestone.name}}
                  </td>
                  <td style="vertical-align:top">
                    <md-icon class="icon-action" @click.native="unarchive(milestone)" >unarchive</md-icon>
                    <md-tooltip class="archive-action-tooltip" md-delay="300">Unarchive milestone</md-tooltip>
                  </td>
                  <td style="vertical-align:top">
                    <md-icon class="icon-action" @click.native="showDeletionConfirmationPopUp(milestone)" >delete</md-icon>
                    <md-tooltip class="archive-action-tooltip" md-delay="300">Delete milestone permanently</md-tooltip>
                  </td>
              </tr>
          </table>
        </div>
    </el-popover>
  </div>
</template>

<script>
import api from '@/api/api';
import notify from '@/utils/notificationsUtils';
import {
  Popover,
  Button,
  Tooltip,
  InfiniteScroll,
} from 'element-ui';
import Swal from 'sweetalert2';
import UpdateStatus from '../../UpdateStatus';

const swalWithCustomButtons = Swal.mixin({
  customClass: {
    confirmButton: 'md-button md-success btn-fill',
    cancelButton: 'md-button md-danger btn-fill',
  },
  buttonsStyling: false,
});

export default {
  components: {
    [Button.name]: Button,
    [Popover.name]: Popover,
    [Tooltip.name]: Tooltip,
  },
  directives: {
    [InfiniteScroll.name]: InfiniteScroll,
  },
  name: 'archived-milestones',
  props: {
    taskId: {
      type: Number,
      required: true,
    },
    playbookId: {
      type: String,
      required: true,
    },
    activityId: {
      type: String,
      required: true,
    },
    milestones: {
      type: Array,
      required: true,
      default: () => [],
      description: 'This is the  list of archived milestones.',
    },
  },
  data() {
    return {
      popoverVisible: false,
    };
  },
  methods: {
    showDeletionConfirmationPopUp(milestone) {
      this.isDeletionPopUpOpen = true;
      swalWithCustomButtons
        .fire({
          title: 'Are you sure you want to permanently delete this milestone :',
          text: `"${milestone.name}"`,
          icon: 'warning',
          showCancelButton: true,
          confirmButtonText: 'Yes, remove it!',
          buttonsStyling: false,
          onClose: this.closeIsDeletionPopUpOpen,
        })
        .then((result) => {
          if (result.value) {
            this.delete(milestone);
          }
        });
    },
    delete(milestone) {
      const deleteMilestoneCommand = {
        // eslint-disable-next-line no-underscore-dangle
        playbookId: this.playbookId,
        activityId: this.activityId,
        milestoneId: milestone.id,
        type: 'DeleteMilestoneCommand',
      };
      const taskWorkCommand = {
        action: 'WORK',
        taskWorkDTO: {
          type: 'playbook task',
          command: deleteMilestoneCommand,
        },
      };
      this.$emit('status', UpdateStatus.UPDATING);
      return api.assess
        .post(`/tasks/${this.taskId}`, taskWorkCommand)
        .then((response) => {
          //console.log('Milestone successfully deleted');
          this.fetchPlaybook();
          this.popoverVisible = false;
          this.$emit('status', UpdateStatus.SAVED);
        })
        .catch((error) => {
          const errorMessage = `Could not delete milestone : ${error.response.data.message || ''}`;
          notify.notifyError(errorMessage, this);
          this.$emit('status', UpdateStatus.FAILED);
        });
    },
    unarchive(milestone) {
      const archiveMilestonesCommand = {
        type: 'UnarchiveMilestoneCommand',
        // eslint-disable-next-line no-underscore-dangle
        playbookId: this.playbookId,
        activityId: this.activityId,
        milestoneId: milestone.id,
      };
      const answerPayload = {
        action: 'WORK',
        taskWorkDTO: {
          type: 'playbook task',
          command: archiveMilestonesCommand,
        },
      };
      this.$emit('status', UpdateStatus.UPDATING);
      api.assess
        .post(`/tasks/${this.taskId}`, answerPayload)
        .then((response) => {
          this.fetchPlaybook();
          this.popoverVisible = false;
          this.$emit('status', UpdateStatus.SAVED);
        })
        .catch((error) => {
          const errorMessage = `Could not archive milestone : ${error.response
            .data.message || ''}`;
          notify.notifyError(errorMessage, this);
          this.$emit('status', UpdateStatus.FAILED);
        });
    },
    fetchPlaybook() {
      const payload = {
        taskId: this.taskId,
        vm: this,
      };
      return this.$store.dispatch('playbooks/fetchPlaybook', payload);
    },
  },
};
</script>

<style lang="scss" scoped >
.archive{
  display: inline-block;
}
.archive-popover{
  max-height: 400px;
  overflow-y: auto;
  z-index: 4000;
}
.archive-table{
  width: 100%;
}
.archive-action-tooltip {
  z-index: 5000;
}
</style>
